import { IParameter } from "../types";
import { IGetParamsGET_Cities_JSON } from "./type";

function getParamsGET_CITIES_JSON({
    NFIRST_ROWNUM = 1,
    NLAST_ROWNUM = 20,
    CFILTER = '',
    NID = null,
}: IGetParamsGET_Cities_JSON): IParameter[] {
    return [
        { name: "NFIRST_ROWNUM", value: NFIRST_ROWNUM },
        { name: "NLAST_ROWNUM", value: NLAST_ROWNUM },
        { name: "CFILTER", value: CFILTER },
        { name: "NID", value: NID },
    ];
}

export {
    getParamsGET_CITIES_JSON,
}